<template>
  <div>
    <o-modal :active="isComponentModalActive" has-modal-card :canCancel="false" class="modal-sm">
      <div class="modal-card is-small custom-popover">
        <header class="modal-card-head">
          <p class="modal-card-title">Select BIMPLUS Team & Project</p>
        </header>
        <section class="modal-card-body is-visible" :class="{'overflow-auto':folderPage}">
          <div>
            <span class="is-size-3 has-text-weight-bold has-text-black-bis">
              BIMPLUS Team
            </span>
            <mf-multi-select
              v-model="selectedTeam"
              :options="teams"
              :closeOnSelect="true"
              label="name"
              track-by="slug"
              placeholder="Select Team"
              :multiple="false"
              :hideSelected="false"
              :allow-empty="false"
              @update:modelValue="getProjects()"
              ></mf-multi-select>
              <div>
                <span class="is-size-3 has-text-weight-bold has-text-black-bis">
                  BIMPLUS Project
                </span>
                <mf-multi-select
                  v-model="selectedProject"
                  :options="projects"
                  :closeOnSelect="true"
                  label="name"
                  track-by="id"
                  placeholder="Select Project"
                  :disabled="$_.isEmpty(selectedTeam)"
                  :multiple="false"
                  :hideSelected="false"
                  :allow-empty="false"
                  @update:modelValue="getModels()"
                  ></mf-multi-select>
              </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <div class="column is-paddingless">
            <button
              class="button is-outlined"
              type="button"
              @click="
              $emit('close-modal');"
            >Cancel</button>
          </div>
          <div class="column is-narrow is-paddingless">
            <button
              class="button has-background-black-bis has-text-white"
              type="button"
              :disabled="$_.isEmpty(selectedProject)"
              @click="linkBimplusModel"
            >Link BIMPLUS Model</button>
          </div>
        </footer>
      </div>
    </o-modal>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRef,
  toRefs,
} from 'vue';
import BimPlus from '@/models/BimPlus';
import { useStore } from 'vuex';
import MfMultiSelect from '@/components/abstract/MfMultiSelect.vue';

export default defineComponent({
  components: { MfMultiSelect },
  name: 'BimPlusModelList',
  props: {
    isComponentModalActive: {
      type: Boolean,
      default: false,
    },
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const data = reactive({
      manufactonProject: {},
      teams: [],
      projects: [],
      models: [],
      selectedTeam: null,
      selectedProject: null,
      selectedModel: null,
      accessToken: null,
      folderPage: false,
    });

    const getTeams = async () => {
      try {
        data.teams = await BimPlus.getTeams(data.accessToken);
      } catch (e) {
        console.error(e);
      }
    };

    const getProjects = async () => {
      try {
        if (data.selectedTeam) {
          const params = {
            access_token: data.accessToken,
            bimTeamslug: data.selectedTeam.slug,
          };
          data.projects = await BimPlus.getProjects(params);
        }
      } catch (e) {
        console.error(e);
      }
    };

    const getModels = async () => {
      try {
        if (data.selectedTeam && data.selectedProject) {
          const params = {
            access_token: data.accessToken,
            bimTeamslug: data.selectedTeam.slug,
            bimProjectId: data.selectedProject.id,
          };
          data.models = await BimPlus.getModels(params);
        }
      } catch (e) {
        console.error(e);
      }
    };

    const linkBimplusModel = async () => {
      try {
        if (data.selectedTeam && data.selectedProject) {
          const bModels = [];
          data.models.forEach((m) => {
            bModels.push({ id: m.id, name: m.name, topologyId: m.topologyId });
          });

          const params = {
            projectId: props.project.id,
            access_token: data.accessToken,
            bimTeam: { id: data.selectedTeam.slug, name: data.selectedTeam.name },
            bimProject: { id: data.selectedProject.id, name: data.selectedProject.name },
            bimModels: bModels,
          };
          data.manufactonProject = await BimPlus.setBimplusDetails(params);
          if (data.manufactonProject !== null) {
            emit('close-modal', { reRender: true });
          }
        }
      } catch (e) {
        console.error(e);
      }
    };

    onMounted(() => {
      data.accessToken = store.state.bimplus.access_token;
      getTeams();
    });

    return {
      ...toRefs(data),
      getTeams,
      getProjects,
      getModels,
      linkBimplusModel,
    };
  },
});
</script>

<style scoped>
div :deep(.overflow-auto) {
  overflow: auto !important;
}
</style>
